import { useState, useEffect } from 'react';
import { getEnv } from '@affine/core/modules/cloud/constant';

// 全局状态，确保只加载一次
const globalBlackFridayState = {
  config: null as any,
  loading: false,
  promise: null as Promise<any> | null,
};

export const usePreloadedBlackFriday = () => {
  const [isReady, setIsReady] = useState(
    globalBlackFridayState.config !== null
  );
  const [config, setConfig] = useState(globalBlackFridayState.config);

  useEffect(() => {
    // 如果已经有配置，直接使用
    if (globalBlackFridayState.config) {
      setConfig(globalBlackFridayState.config);
      setIsReady(true);
      return;
    }

    // 如果正在加载，等待加载完成
    if (globalBlackFridayState.loading && globalBlackFridayState.promise) {
      globalBlackFridayState.promise.then(data => {
        setConfig(data);
        setIsReady(true);
      });
      return;
    }

    // 开始加载配置
    globalBlackFridayState.loading = true;
    const env = getEnv();
    const url = `https://wy-static.wenxiaobai.com/wenxiaobai-web/muset/${env}/isShowBlackFriday.json`;

    globalBlackFridayState.promise = fetch(url)
      .then(res => {
        if (!res.ok) {
          throw new Error(`HTTP error! status: ${res.status}`);
        }
        return res.json();
      })
      .then(data => {
        globalBlackFridayState.config = data;
        globalBlackFridayState.loading = false;
        setConfig(data);
        setIsReady(true);
        return data;
      })
      .catch(error => {
        console.error('Failed to load BlackFriday config:', error);
        // 返回默认配置
        const defaultConfig = { isShowBlackFriday: false };
        globalBlackFridayState.config = defaultConfig;
        globalBlackFridayState.loading = false;
        setConfig(defaultConfig);
        setIsReady(true);
        return defaultConfig;
      });
  }, []);

  return {
    isReady,
    isShowBlackFriday: config?.isShowBlackFriday ?? false,
    config,
  };
};

// 预加载函数，可以在应用启动时调用
export const preloadBlackFridayConfig = () => {
  if (globalBlackFridayState.config || globalBlackFridayState.loading) {
    return (
      globalBlackFridayState.promise ||
      Promise.resolve(globalBlackFridayState.config)
    );
  }

  globalBlackFridayState.loading = true;
  const env = getEnv();
  const url = `https://wy-static.wenxiaobai.com/wenxiaobai-web/muset/${env}/isShowBlackFriday.json`;

  globalBlackFridayState.promise = fetch(url)
    .then(res => {
      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }
      return res.json();
    })
    .then(data => {
      globalBlackFridayState.config = data;
      globalBlackFridayState.loading = false;
      return data;
    })
    .catch(error => {
      console.error('Failed to preload BlackFriday config:', error);
      const defaultConfig = { isShowBlackFriday: false };
      globalBlackFridayState.config = defaultConfig;
      globalBlackFridayState.loading = false;
      return defaultConfig;
    });

  return globalBlackFridayState.promise;
};
